import React from "react";

function DisclaimerTerms() {
  return (
    <div>
      <h2>Terms of Service</h2>
      <p>Last updated: [Insert Date]</p>

      <p>
        Welcome to Thenics4All (“we”, “our”, “us”). By accessing or using our
        website, mobile applications, and related services (collectively, the
        “Services”), you agree to comply with and be bound by these Terms of
        Service (“Terms”). If you do not agree, please do not use the Services.
      </p>

      <h3>1. Eligibility</h3>
      <p>
        You must be at least 13 years old (or the minimum age required in your
        country) to use the Services. If you are under 18, you may use the
        Services only with involvement of a parent or guardian.
      </p>

      <h3>2. User Accounts</h3>
      <p>
        You are responsible for maintaining the confidentiality of your login
        credentials and for all activity under your account. You agree to
        provide accurate, current, and complete information.
      </p>

      <h3>3. Acceptable Use</h3>
      <p>
        You agree not to use the Services to post or share content that is
        illegal, harmful, threatening, abusive, harassing, defamatory,
        obscene, or otherwise objectionable, or that violates any third-party
        rights, including intellectual property rights.
      </p>

      <h3>4. Content Ownership & License</h3>
      <p>
        You retain ownership of the content you create and upload. By
        submitting content to the Services, you grant us a worldwide,
        non-exclusive, royalty-free license to use, reproduce, adapt, and
        distribute that content solely for operating, promoting, and improving
        the Services.
      </p>

      <h3>5. Fitness Disclaimer</h3>
      <p>
        The content provided through the Services is for informational and
        educational purposes only. You should consult a physician before
        starting any exercise program. Use of our training content is at your
        own risk.
      </p>

      <h3>6. Third-Party Integrations</h3>
      <p>
        Our Services may integrate with third-party platforms to enable
        content sharing, analytics, and community engagement. These platforms
        include, but are not limited to:
      </p>
      <ul>
        <li>YouTube and YouTube Shorts</li>
        <li>Instagram Reels and Facebook</li>
        <li>
          TikTok –{" "}
          <a
            href="https://developers.tiktok.com/doc/content-posting-api-get-started?enter_method=left_navigation"
            target="_blank"
            rel="noopener noreferrer"
          >
            TikTok Content Posting API
          </a>
        </li>
        <li>
          Twitter/X –{" "}
          <a
            href="https://docs.x.com/x-api/getting-started/getting-access"
            target="_blank"
            rel="noopener noreferrer"
          >
            X API
          </a>
        </li>
        <li>
          Reddit –{" "}
          <a
            href="https://praw.readthedocs.io/en/stable/"
            target="_blank"
            rel="noopener noreferrer"
          >
            PRAW API
          </a>{" "}
          (Note: video posting support is limited)
        </li>
        <li>
          LinkedIn –{" "}
          <a
            href="https://learn.microsoft.com/en-us/linkedin/marketing/community-management/shares/videos-api?view=li-lms-2024-11&tabs=http"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn Video API
          </a>
        </li>
        <li>Discord</li>
        <li>
          Snapchat –{" "}
          <a
            href="https://developers.snap.com/api/marketing-api/Public-Profile-API/Introduction"
            target="_blank"
            rel="noopener noreferrer"
          >
            Snapchat Public Profile API
          </a>
        </li>
      </ul>
      <p>
        Your use of these platforms is subject to their respective terms and
        privacy policies. We do not control and are not responsible for the
        content, policies, or practices of these third parties.
      </p>

      <h3>7. Termination</h3>
      <p>
        We may suspend or terminate your access to the Services at our sole
        discretion if you violate these Terms or engage in conduct that may
        harm the Services or other users.
      </p>

      <h3>8. Limitation of Liability</h3>
      <p>
        To the fullest extent permitted by law, we are not liable for any
        indirect, incidental, special, consequential, or punitive damages,
        including lost profits or data, arising from your use of the Services.
      </p>

      <h3>9. Changes to Terms</h3>
      <p>
        We may update these Terms from time to time. Changes will be effective
        upon posting. Your continued use of the Services constitutes acceptance
        of the updated Terms.
      </p>

      <h3>10. Contact Us</h3>
      <p>
        If you have any questions about these Terms, contact us at:{" "}
        <a href="mailto:support@thenics4all.com">support@thenics4all.com</a>
      </p>
    </div>
  );
}

export default DisclaimerTerms;
